var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('ValidationService', ['$http', function ($http) {
    var usa = new RegExp("^[0-9]{5}$");
    var canada = new RegExp("[A-Za-z][0-9][A-Za-z][0-9][A-Za-z][0-9]");

    var patterns = {
        name: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
        email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
        phone: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
        wholenumberunsigned: /^(0|[1-9]\d*)$/,
        decimalnumberunsigned: /^\d*\.?\d+$/,
        timetwelvehourformat: /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/,
        numberswithoutdecimal: /^([1-9][0-9]*)$/
    }

    return {
        isRequired: function (value) {
            return this.isEmpty(value) && this.hasLength(value);
        },
        isEmpty: function (value) {
            if (value == undefined || value == null || value == "") {
                return true;
            }
            return false;
        },
        hasLength: function (value) {
            if (value.length > 0) {
                return true;
            }
            return false;
        },
        isValidZipCode: function (country, value) {
            if (!this.isEmpty(value)) {
                if (country == "US") {
                    return usa.test(value);
                }
                else if (country == "CA") {
                    var newvalue = value.replace(/[\s]/g, '').replace('-', '');
                    return canada.test(newvalue);
                }
                else {
                    return true;
                }
            }
            return false;
        },
        getRegExpPattern: function () {
            return patterns;
        },
        formatPhoneNumber: function (phoneNumber) {
            var cleaned = ('' + phoneNumber).replace(/\D/g, '')
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
            }
            return null;
        },
        isValidEmail: function (value) {
            return patterns.email.test(value);
        }
    }
}]);
